import MyPortfolioIndividual from './MyPortfolioIndividual'
import MyPortfolioEntity from './MyPortfolioEntity'


export  {MyPortfolioIndividual, MyPortfolioEntity} 


// WEBPACK FOOTER //
// ./src/components/Profile/SubMyPortfolio/index.js